import type { Notification } from '@dataTypes/notification.types'
import { NotificationPriority } from '@dataTypes/notification.types'

/** Mock notifications for UI presentation. March and April 2026. */
export const mockNotifications: Notification[] = [
  // Critical – March 2026
  {
    id: '1',
    priority: NotificationPriority.CRITICAL,
    title: 'Appointment Overlap Detected (Cross-Location)',
    date: 'March 4, 2026',
    time: '9:00 AM',
    message:
      "Dr. Martinez's calendar has a scheduling conflict at the downtown location.",
    actionButtonText: 'Resolve scheduling conflict',
  },
  {
    id: '2',
    priority: NotificationPriority.CRITICAL,
    title: 'Claim Rejected (Immediate Correction)',
    date: 'March 10, 2026',
    time: '1:45 PM',
    message:
      "Stephen John's insurance claims has been rejected due to missing/incorrect patient details.",
    actionButtonText: 'Review claims documents',
  },
  {
    id: '3',
    priority: NotificationPriority.CRITICAL,
    title: 'Critical Form Not Signed (Check-in)',
    date: 'March 12, 2026',
    time: '11:00 AM',
    message:
      'Alex William is checking in but her forms are incomplete. Patient should complete her forms at the kiosk.',
    actionButtonText: "Send patient's OTP at Kiosk",
  },
  {
    id: '4',
    priority: NotificationPriority.CRITICAL,
    title: 'Allergy Alert',
    date: 'March 6, 2026',
    time: '2:24 PM',
    message: 'John Smith is allergic to penicillin.',
    actionButtonText: 'Update treatment plan',
  },
  {
    id: '43',
    priority: NotificationPriority.URGENT,
    title: 'Pending Payment',
    date: 'March 6, 2026',
    time: '3:10 PM',
    message:
      "Laura Hill's payment for the approved treatment plan is still pending.",
    actionButtonText: 'Check payment status',
  },
  {
    id: '44',
    priority: NotificationPriority.LOW,
    title: 'Payment Processed',
    date: 'March 6, 2026',
    time: '5:20 PM',
    message: "Mark Rivera's payment has been successfully processed.",
    actionButtonText: 'View transaction history',
  },
  {
    id: '5',
    priority: NotificationPriority.CRITICAL,
    title: 'Allergy Alert',
    date: 'March 7, 2026',
    time: '10:15 AM',
    message: 'Sarah Lee is allergic to aspirin.',
    actionButtonText: 'Update treatment plan',
  },
  {
    id: '6',
    priority: NotificationPriority.CRITICAL,
    title: 'Allergy Alert',
    date: 'March 15, 2026',
    time: '10:30 AM',
    message: 'Michael Chen is allergic to shellfish.',
    actionButtonText: 'Update treatment plan',
  },
  // March 5, 2026 – 2 per column (Critical, Urgent, Low)
  {
    id: '39',
    priority: NotificationPriority.CRITICAL,
    title: 'Allergy Alert',
    date: 'March 5, 2026',
    time: '8:00 AM',
    message: 'Olivia Brown is allergic to penicillin.',
    actionButtonText: 'Update treatment plan',
  },
  {
    id: '40',
    priority: NotificationPriority.CRITICAL,
    title: 'Claim Rejected (Immediate Correction)',
    date: 'March 5, 2026',
    time: '11:30 AM',
    message:
      "Daniel Green's insurance claim has been rejected due to missing patient details.",
    actionButtonText: 'Review claims documents',
  },
  {
    id: '35',
    priority: NotificationPriority.URGENT,
    title: 'Pending Insurance Verification',
    date: 'March 5, 2026',
    time: '9:00 AM',
    message: "Anna Davis's insurance is yet to be verified.",
    actionButtonText: 'Check insurance plan',
  },
  {
    id: '41',
    priority: NotificationPriority.URGENT,
    title: 'Pending Payment',
    date: 'March 5, 2026',
    time: '4:15 PM',
    message:
      "Jessica Taylor's payment for the approved treatment plan is still pending.",
    actionButtonText: 'Check payment status',
  },
  {
    id: '36',
    priority: NotificationPriority.LOW,
    title: 'Payment Processed',
    date: 'March 5, 2026',
    time: '2:00 PM',
    message: "Chris Evans's payment has been successfully processed.",
    actionButtonText: 'View transaction history',
  },
  {
    id: '42',
    priority: NotificationPriority.LOW,
    title: 'Approval Granted',
    date: 'March 5, 2026',
    time: '3:45 PM',
    message:
      "Kevin Martinez's insurance claim has been approved. Review the details for next steps.",
    actionButtonText: 'Contact Support',
  },
  // Urgent – March 2026
  {
    id: '7',
    priority: NotificationPriority.URGENT,
    title: 'Pending Payment',
    date: 'March 4, 2026',
    time: '8:30 AM',
    message:
      "Eric Larson's payment for the approved treatment plan is still pending.",
    actionButtonText: 'Check payment status',
  },
  {
    id: '8',
    priority: NotificationPriority.URGENT,
    title: 'Denial of Claim',
    date: 'March 8, 2026',
    time: '1:45 PM',
    message:
      "Eric Larson's recent claim has been denied due to lack of coverage.",
    actionButtonText: 'Review denial reasons',
  },
  {
    id: '37',
    priority: NotificationPriority.CRITICAL,
    title: 'Allergy Alert',
    date: 'March 8, 2026',
    time: '10:00 AM',
    message: 'Emma Wilson is allergic to latex.',
    actionButtonText: 'Update treatment plan',
  },
  {
    id: '38',
    priority: NotificationPriority.LOW,
    title: 'Claim Under Review',
    date: 'March 8, 2026',
    time: '3:30 PM',
    message:
      'The claim for patient Ryan Moore is currently being evaluated by the claims department.',
    actionButtonText: 'View claim status',
  },
  {
    id: '9',
    priority: NotificationPriority.URGENT,
    title: 'Approved for Treatment',
    date: 'March 9, 2026',
    time: '11:00 AM',
    message: 'Insurance has approved the treatment plan for Eric Larson.',
    actionButtonText: 'View treatment details',
  },
  {
    id: '10',
    priority: NotificationPriority.URGENT,
    title: 'Claim Under Review',
    date: 'March 10, 2026',
    time: '10:15 AM',
    message:
      'The claim submitted by Eric Larson is currently under review by the claims department.',
    actionButtonText: 'Contact claims department',
  },
  {
    id: '11',
    priority: NotificationPriority.URGENT,
    title: 'Pending Insurance Verification',
    date: 'March 14, 2026',
    time: '2:24 PM',
    message: "Eric Larson's insurance is yet to be verified.",
    actionButtonText: 'Check insurance plan',
  },
  {
    id: '12',
    priority: NotificationPriority.URGENT,
    title: 'Pending Payment',
    date: 'March 18, 2026',
    time: '3:30 PM',
    message:
      "Maria Garcia's payment for the approved treatment plan is still pending.",
    actionButtonText: 'Check payment status',
  },
  // Low Priority – March 2026
  {
    id: '13',
    priority: NotificationPriority.LOW,
    title: 'Payment Processed',
    date: 'March 2, 2026',
    time: '8:45 AM',
    message: "James Alvarez's payment has been successfully processed.",
    actionButtonText: 'View transaction history',
  },
  {
    id: '14',
    priority: NotificationPriority.LOW,
    title: 'Approval Granted',
    date: 'March 15, 2026',
    time: '11:30 AM',
    message:
      "Jason Medoza's insurance claim has been approved. Review the details for next steps.",
    actionButtonText: 'Contact Support',
  },
  {
    id: '15',
    priority: NotificationPriority.LOW,
    title: 'Chart Entry Edited/Updated (Provider)',
    date: 'March 7, 2026',
    time: '2:24 PM',
    message: 'Dr James added a note for Eric Larson.',
    actionButtonText: '',
  },
  {
    id: '16',
    priority: NotificationPriority.LOW,
    title: 'Claim Under Review',
    date: 'March 18, 2026',
    time: '9:15 AM',
    message:
      'Your claim is currently being evaluated. Please allow up to 5 business days for processing.',
    actionButtonText: 'View claim status',
  },
  {
    id: '17',
    priority: NotificationPriority.LOW,
    title: 'New Location Added to Network',
    date: 'March 20, 2026',
    time: '9:00 AM',
    message:
      'Admin Mike added a new location - 789 HEALTH PARK DR, LOS ANGELES, CA',
    actionButtonText: '',
  },
  {
    id: '18',
    priority: NotificationPriority.LOW,
    title: 'Additional Information Required',
    date: 'March 22, 2026',
    time: '4:00 PM',
    message:
      'We need more information to proceed with your claim. Check your email for details.',
    actionButtonText: 'Help Center',
  },
  // Patient-specific – March 2026
  {
    id: '19',
    priority: NotificationPriority.CRITICAL,
    title: 'Claim Rejected (Immediate Correction)',
    date: 'March 10, 2026',
    time: '1:45 PM',
    message:
      "John Doe's insurance claims has been rejected due to missing/incorrect patient details.",
    actionButtonText: 'Review claims documents',
    patient_id: 'mock-patient-1',
  },
  {
    id: '20',
    priority: NotificationPriority.URGENT,
    title: 'Pending Payment',
    date: 'March 11, 2026',
    time: '3:30 PM',
    message:
      "John Doe's payment for the approved treatment plan is still pending.",
    actionButtonText: 'Check payment status',
    patient_id: 'mock-patient-1',
  },
  // Critical – April 2026
  {
    id: '21',
    priority: NotificationPriority.CRITICAL,
    title: 'Appointment Overlap Detected (Cross-Location)',
    date: 'April 3, 2026',
    time: '9:00 AM',
    message:
      "Dr. Claire's calendar is double-booked across two separate locations.",
    actionButtonText: 'Resolve scheduling conflict',
  },
  {
    id: '22',
    priority: NotificationPriority.CRITICAL,
    title: 'Claim Rejected (Immediate Correction)',
    date: 'April 7, 2026',
    time: '2:00 PM',
    message:
      "Lisa Wong's insurance claims has been rejected due to missing/incorrect patient details.",
    actionButtonText: 'Review claims documents',
  },
  {
    id: '23',
    priority: NotificationPriority.CRITICAL,
    title: 'Allergy Alert',
    date: 'April 9, 2026',
    time: '10:00 AM',
    message: 'David Kim is allergic to peanuts.',
    actionButtonText: 'Update treatment plan',
  },
  {
    id: '24',
    priority: NotificationPriority.CRITICAL,
    title: 'Critical Form Not Signed (Check-in)',
    date: 'April 14, 2026',
    time: '8:45 AM',
    message:
      'Amanda Foster is checking in but her forms are incomplete. Patient should complete her forms at the kiosk.',
    actionButtonText: "Send patient's OTP at Kiosk",
  },
  // Urgent – April 2026
  {
    id: '25',
    priority: NotificationPriority.URGENT,
    title: 'Pending Payment',
    date: 'April 2, 2026',
    time: '11:30 AM',
    message:
      "Robert Brown's payment for the approved treatment plan is still pending.",
    actionButtonText: 'Check payment status',
  },
  {
    id: '26',
    priority: NotificationPriority.URGENT,
    title: 'Denial of Claim',
    date: 'April 5, 2026',
    time: '1:15 PM',
    message:
      "Thomas Clark's recent claim has been denied due to lack of coverage.",
    actionButtonText: 'Review denial reasons',
  },
  {
    id: '27',
    priority: NotificationPriority.URGENT,
    title: 'Approved for Treatment',
    date: 'April 12, 2026',
    time: '3:00 PM',
    message: 'Insurance has approved the treatment plan for Jennifer Adams.',
    actionButtonText: 'View treatment details',
  },
  {
    id: '28',
    priority: NotificationPriority.URGENT,
    title: 'Claim Under Review',
    date: 'April 18, 2026',
    time: '10:00 AM',
    message:
      'The claim submitted by Christopher Bell is currently under review by the claims department.',
    actionButtonText: 'Contact claims department',
  },
  // Low Priority – April 2026
  {
    id: '29',
    priority: NotificationPriority.LOW,
    title: 'Payment Processed',
    date: 'April 1, 2026',
    time: '8:20 AM',
    message: "Robert Brown's payment has been successfully processed.",
    actionButtonText: 'View transaction history',
  },
  {
    id: '30',
    priority: NotificationPriority.LOW,
    title: 'Approval Granted',
    date: 'April 8, 2026',
    time: '10:00 AM',
    message:
      "Amanda Foster's insurance claim has been approved. Review the details for next steps.",
    actionButtonText: 'Contact Support',
  },
  {
    id: '31',
    priority: NotificationPriority.LOW,
    title: 'Chart Entry Edited/Updated (Provider)',
    date: 'April 15, 2026',
    time: '1:30 PM',
    message: 'Dr. Patel added a note for Thomas Clark.',
    actionButtonText: '',
  },
  {
    id: '32',
    priority: NotificationPriority.LOW,
    title: 'New Location Added to Network',
    date: 'April 20, 2026',
    time: '9:00 AM',
    message: 'Admin Sarah added a new location - 431 AVIATION WAY, GARDENA, CA',
    actionButtonText: '',
  },
  {
    id: '33',
    priority: NotificationPriority.LOW,
    title: 'Additional Information Required',
    date: 'April 22, 2026',
    time: '4:00 PM',
    message:
      'We need more information to proceed with your claim. Check your email for details.',
    actionButtonText: 'Help Center',
  },
  {
    id: '34',
    priority: NotificationPriority.LOW,
    title: 'Claim Denied',
    date: 'April 25, 2026',
    time: '4:10 PM',
    message:
      'Unfortunately, your claim has been denied. Review the denial reason and contact support if needed.',
    actionButtonText: 'Review Denial',
  },
]
